import React from "react";
import "./Products.css";
import Common_Category_Card from "../../common_components/common_category_card/Common_Category_Card";
import { useNavigate } from "react-router-dom";
const Products = ({ data }) => {
  const navigate = useNavigate();
  return (
    <section className="Products Category">
      <div className="custom_container">
        <div className="content_div">
          <div className="row">
            {data?.map((item, index) => (
              <div className="col-xl-3 col-md-4 col-6" key={index}>
                <Common_Category_Card
                  imgSrc={item?.img}
                  title={item?.name}
                  onClick={() => navigate(item?.link)}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;
